module.exports = __webpack_public_path__ + "img/carwise.54ff3551.png";